import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id,
    projId,
    content: inputContent,
    accessToken,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.projectShare.saveProjectItem, {
        id,
        projId,
        content: inputContent,
        accessToken,
    }, options);
    if (error) return { error, status };
    return content || {};
};

